import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useKeycloak } from '@react-keycloak/web'
import YoutubeSearchedForIcon from '@material-ui/icons/YoutubeSearchedFor'

import searchPageContext from '../../FiltersComponent/context/context'
import { formatDate } from '../../Utility/Utility'
import { saveSavedSearch } from '../../Services/propertySearchService'
import { getSearchCriteriaToSave, getErrorAlertDuration } from '../../Utility/Utility'
import { pollMessageStatus } from '../../../PropertyList/Utility/GetMessageStatus/GetMessageStatus'
import { readyToUpdate, pendingResponse } from '../../../PropertyList/Utility/PropertyListUtility'

const UpdateExistingSearch = props => {
    const [updateClicked, setUpdateClicked] = useState(false)
    const { keycloak } = useKeycloak()
    let [checkedSavedSearch, setCheckedSavedSearch] = useState(undefined)

    let { fetchSavedSearch, savedSearch, setalertProps, setShowAlert,
        searchCriteria, openModalWindow } = useContext(searchPageContext)

    useEffect(() => {
        if (updateClicked) {
            handleUpdate()
        }
    }, [updateClicked])

    const getUpdatePayload = () => {
        try {

            const newSearchCriteria = { ...getSearchCriteriaToSave(searchCriteria) }

            const payload = {
                'action': 'modify',
                'data': {
                    'userId': keycloak.subject,
                    'omniViewUserId': checkedSavedSearch.omniViewUserId,
                    'isCart': false,
                    'isTargetMarket': checkedSavedSearch.isTargetMarket,
                    'name': checkedSavedSearch.name,
                    'omniViewSearchCriteria': '',
                    'omniViewPropertyListId': checkedSavedSearch.omniViewPropertyListId,
                    'polarisPropertySearchCriteriaId': checkedSavedSearch.polarisPropertySearchCriteriaId,
                    'polarisSearchCriteria': JSON.stringify(newSearchCriteria)
                }
            }
            return payload
        }
        catch (e) {
            console.log('Error :: ', e)
        }
    }

    const onUpdate = async (message, type) => {

        if (type === 'success') {
            await fetchSavedSearch()
        }

        setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
        setShowAlert(true)

        openModalWindow(false)

    }

    const handleUpdate = async () => {
        try {
            if (checkedSavedSearch) {

                let response
                if (await readyToUpdate()) {
                    const payload = getUpdatePayload()
                    openModalWindow(true)
                    props.handleClose()
                    response = await saveSavedSearch(payload)
                } else {
                    response = await pendingResponse()
                }

                setCheckedSavedSearch(undefined)
                setUpdateClicked(false)

                if (response && response.status === 200) {
                    pollMessageStatus(response.data.messageId, onUpdate, '', 'Search Updated!! ', 'Something went wrong !!')
                } else {
                    const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                    setalertProps({ message: errorMessage, type: 'error' })
                    setShowAlert(true)
                }

            }
        } catch (e) {
            console.log('Error ::: ', e)
        }
    }

    const getCheckedStatus = value => {
        let returnVal = false

        if (checkedSavedSearch && checkedSavedSearch.polarisPropertySearchCriteriaId === value.polarisPropertySearchCriteriaId && checkedSavedSearch.omniViewPropertyListId === value.omniViewPropertyListId) {
            returnVal = true
        }

        return returnVal
    }

    return (
        <>
            <div data-testid="test-div-update-save-search" className="flex flex-col pt-4">
                <div className="flex flex-row border-b-1 border-base px-4 pb-2">
                    <span className="pb-4">
                        <YoutubeSearchedForIcon></YoutubeSearchedForIcon>
                    </span>
                    <span className="px-2">
                        Update existing search
                    </span>
                </div>

                <div className="border-b-1 border-base flex flex-col overflow-y-auto popover-w disable-scrollbars h-300">
                    {savedSearch.map(value => (
                        <>
                            {!value.isCart &&
                                <div onClick={() => { setCheckedSavedSearch(value) }} key={value.name} className="flex flex-row justify-between items-center border-b-1 border-base px-3 py-3 cursor-default hover:bg-gray-15">
                                    <div className="px-6 flex flex-col" >
                                        <div className="text-base">
                                            {value.name}
                                        </div>
                                        <div className="text-muted text-1">
                                            Last Modified : {formatDate(value.lastModifiedDate, 'mmDDYYYY')}
                                        </div>
                                    </div>
                                    <div className="pr-4">
                                        <input checked={getCheckedStatus(value)} type="radio" name="radio-saved-search" />
                                    </div>
                                </div>
                            }
                        </>
                    ))}
                </div>
                {savedSearch.length === 0 &&
                    <div className="p-6 border-b-1 border-base">
                        You can Save a Search or a Target market.
                        <br />Come back here to load your saved search.
                    </div>
                }
                <div className="p-4">
                    <div className="flex justify-end space-x-4 mt-auto">
                        <div>
                            <button data-testid="button-cancel" onClick={props.handleClose} className="btn btn-sm" type="button">Close</button>
                        </div>
                        {updateClicked ?
                            <button className="btn btn-sm btn-primary c-disabled">
                                <span className="loader h-5 w-5 mx-2" ></span>
                                <span className="px-2">Updating</span>
                            </button>
                            :
                            <button data-testid="test-btn-update-search" onClick={() => { setUpdateClicked(true) }} className={`btn btn-sm btn-primary ${checkedSavedSearch ? '' : 'c-disabled'}`} > Update </button>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdateExistingSearch

UpdateExistingSearch.propTypes = {
    handleClose: PropTypes.any,
    view: PropTypes.string,
}
